export const isPojo = obj => obj !== null && typeof obj === 'object' && Object.getPrototypeOf(obj) === Object.prototype;
export default isPojo;
